/* eslint
    @typescript-eslint/no-use-before-define: "warn",
    no-inner-declarations: "warn",
    consistent-return: "warn"
*/

import easyfyAxios from '@shared/easyfy.axios';

namespace Meds.Web.Services.ProductRecommendations {
  export interface ProductRecommendationRequest {
    productIds?: string[];
    searchProductId?: string;
    brandId?: string;
    seoCategoryName?: string;
    personalize: boolean;
    isExclusiveToBrand: boolean;
    recommendationType: string;
    productPageHasVideo: boolean;
    noCache: boolean;
  }

  export const GetProductRecommendations = async (
    data: ProductRecommendationRequest
  ): Promise<any> => {
    const productsCacheKey = await buildCacheKey(data);
    return easyfyAxios.post(
      `/api/productrecommendations?handler=productrecommendations${productsCacheKey}`,
      data,
      null
    );
  };

  async function buildCacheKey(
    productRecommendationRequest: ProductRecommendationRequest
  ) {

    if (productRecommendationRequest.noCache) {
      return (`&key=${Date.now().toString()}`);
    }

    let cacheKey = '';

    if (
      productRecommendationRequest.productIds != null &&
      productRecommendationRequest.productIds.length
    ) {
      cacheKey += productRecommendationRequest.productIds.join(',');
    }

    if (productRecommendationRequest.brandId != null) {
      cacheKey += `,${productRecommendationRequest.brandId}`;
    }

    if (productRecommendationRequest.personalize === true) {
      // use the value of our customer cookie as cache value. 
      const medsCid = GetCookieValue('meds_cid');
      if (medsCid != null) {
        cacheKey += `,${medsCid}`;
      }
    }

    if (productRecommendationRequest.recommendationType != null) {
      cacheKey += `,${productRecommendationRequest.recommendationType}`;
    }

    return `&key=${await sha256(cacheKey)}`;
  };

  const GetCookieValue = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }
}

export default Meds.Web.Services.ProductRecommendations;
